import React from 'react';
import { connect } from 'react-redux';
import actions from '../../redux/actions';
import actionTypes from '../../redux/actionTypes';

class ConfirmEmail extends React.Component {
  constructor(props) {
    super(props);

    this.token = props.params.token;
  }

  componentWillMount() {
    this.props.dispatch(actions.getConfirmEmail(this.token));
  }

  componentWillReceiveProps(nextProps) {
    const { status, router, dispatch } = nextProps;

    if (status !== this.props.status) {
      if (status === actionTypes.AUTH_VERIFY_EMAIL_SUCCESS) {
        dispatch(
          actions.alert('success', 'Success! You can login to Cosynd now.')
        );
        router.push('/login');
      } else if (status === actionTypes.AUTH_CONFIRM_EMAIL_ERROR) {
        dispatch(
          actions.alert(
            'error',
            'Invalid Key! Please try to valid confirmation key.'
          )
        );
      } else if (status === actionTypes.AUTH_VERIFY_EMAIL_ERROR) {
        dispatch(
          actions.alert(
            'error',
            'Oops! Something went wrong. Please try to confirm again. If this error persists, please contact us.'
          )
        );
      }
    }
  }

  verify = (e) => {
    e.preventDefault();

    const { dispatch, email } = this.props;
    dispatch(actions.hideAlert());

    if (!email) {
      dispatch(actions.alert('error', 'Email address is not correct.'));
    } else {
      dispatch(actions.verifyEmailByToken(this.token));
    }
  };

  render() {
    const { status, email } = this.props;

    return email ? (
      <div className="confirm-email">
        <h3 className="title">Confirm Your Email Address</h3>

        <p>Please confirm that your email address is {email}</p>
        <hr className="transparent" />

        <div className="action">
          <button
            disabled={status === actionTypes.AUTH_VERIFY_EMAIL_REQUEST}
            onClick={this.verify}
          >
            {status === actionTypes.AUTH_VERIFY_EMAIL_REQUEST && (
              <i className="fa fa-refresh fa-spin fa-fw mr-5px"></i>
            )}
            confirm
          </button>
        </div>
      </div>
    ) : (
      <div className="confirm-email">
        <h3 className="title">Confirm Your Email Address</h3>
        <p>authenticating...</p>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  email: state.auth.email,
  status: state.auth.status,
  error: state.auth.error,
});

export default connect(mapStateToProps)(ConfirmEmail);



// WEBPACK FOOTER //
// src/components/Auth/ConfirmEmail.jsx